import { render, staticRenderFns } from "./FcSalary.vue?vue&type=template&id=434bb471&scoped=true&"
import script from "./FcSalary.vue?vue&type=script&lang=js&"
export * from "./FcSalary.vue?vue&type=script&lang=js&"
import style0 from "./FcSalary.vue?vue&type=style&index=0&id=434bb471&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434bb471",
  null
  
)

export default component.exports